import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { LanguageProvider } from "@/components/LanguageProvider";
import { AccessibilityProvider } from "@/contexts/AccessibilityContext";
import { NeuroModeProvider } from "@/contexts/NeuroModeContext";

console.log('main.tsx: Starting application...');

const root = document.getElementById("root");
if (!root) {
  console.error('Root element not found!');
  throw new Error('Root element not found');
}

console.log('main.tsx: Creating React root...');
createRoot(root).render(
  <StrictMode>
    <HelmetProvider>
      <NeuroModeProvider>
        <AccessibilityProvider>
          <LanguageProvider>
            <App />
          </LanguageProvider>
        </AccessibilityProvider>
      </NeuroModeProvider>
    </HelmetProvider>
  </StrictMode>
);
